import React from 'react'

import { Routes } from 'common/constants'
import { useScreenFinishLoadTac } from 'common/hooks/useScreenFinishLoadTac'
import { Outlet } from 'react-router-dom'

export function PrivacyPolicyAcceptanceInitializer() {
  useScreenFinishLoadTac({
    name: 'PrivacyPolicyAcceptance',
    entity: undefined,
    action: 'PrivacyPolicyAcceptanceStartLoad',
    screen: Routes.PRIVACY_POLICY_ACCEPTANCE,
    shouldSend: true,
    logLabel: 'send privacy policy acceptance initializer tac',
  })

  return <Outlet />
}
